// extracted by mini-css-extract-plugin
export var numpadContainer = "_ny-1";
export var phoneButton = "_ny-0";